import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import { Provider } from 'react-redux';
import { store } from './store';
import PostHogProvider from './providers/PostHogProvider';
import AnalyticsAuthSync from './providers/AnalyticsAuthSync';
import { installEarlyErrorBuffer } from './analytics/earlyErrorBuffer';
import { scheduleLazyAnalyticsInit } from './analytics/lazyAnalyticsInit';

installEarlyErrorBuffer();
scheduleLazyAnalyticsInit();

// Import your Clerk Publishable Key
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key. Add REACT_APP_CLERK_PUBLISHABLE_KEY to your .env file');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      afterSignInUrl="/dashboard"
      afterSignUpUrl="/dashboard"
    >
      <Provider store={store}>
        <PostHogProvider>
          <AnalyticsAuthSync />
          <App />
        </PostHogProvider>
      </Provider>
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals();
